import { takeLatest, call, put } from 'redux-saga/effects';
import { getMerchantAndDate } from 'redux/rootSaga';
import {
  FETCH_FEEDBACK_INSIGHTS_OVERVIEW,
  FETCH_FEEDBACK_INSIGHTS_RATING_TREND,
  FETCH_FEEDBACK_INSIGHTS_SERVICE_PERIOD,
  FETCH_FEEDBACK_INSIGHTS_OUTLET_COMPARISON,
} from './constants';
import {
  feedbackInsightsOverviewLoadedAction,
  feedbackInsightsOverviewFailedAction,
  feedbackInsightsRatingTrendLoadedAction,
  feedbackInsightsRatingTrendFailedAction,
  feedbackInsightsServicePeriodLoadedAction,
  feedbackInsightsServicePeriodFailedAction,
  feedbackInsightsOutletComparisonLoadedAction,
  feedbackInsightsOutletComparisonFailedAction,
} from './actions';
import {
  getFeedbackInsightsOverview,
  getFeedbackInsightsRatingTrend,
  getFeedbackInsightsServicePeriod,
  getFeedbackInsightsOutletComparison,
} from './services';

// Builds the shared request payload. `chain_id` is read from localStorage (the
// key the analytics backend expects — same convention as SmartEngage), and
// `merchant_key` is the active merchant list. Returns null when the date range
// isn't ready yet so the caller can skip the request.
function* buildRequestPayload() {
  const { merchantIdList, startDate, endDate, cStartDate, cEndDate } =
    yield getMerchantAndDate();

  if (!startDate || !endDate) return null;

  return {
    chain_id: localStorage.getItem('chain_id'),
    merchant_key: merchantIdList,
    start_date: startDate,
    end_date: endDate,
    c_start_date: cStartDate,
    c_end_date: cEndDate,
  };
}

function* fetchOverviewSaga() {
  try {
    const payload = yield buildRequestPayload();
    if (!payload) return;

    const response = yield call(getFeedbackInsightsOverview, payload);

    yield put(feedbackInsightsOverviewLoadedAction(response?.data || null));
  } catch (e) {
    yield put(feedbackInsightsOverviewFailedAction(e?.message || 'Something went wrong'));
  }
}

function* fetchRatingTrendSaga() {
  try {
    const payload = yield buildRequestPayload();
    if (!payload) return;

    const response = yield call(getFeedbackInsightsRatingTrend, payload);

    yield put(feedbackInsightsRatingTrendLoadedAction(response?.data || null));
  } catch (e) {
    yield put(feedbackInsightsRatingTrendFailedAction(e?.message || 'Something went wrong'));
  }
}

function* fetchServicePeriodSaga() {
  try {
    const payload = yield buildRequestPayload();
    if (!payload) return;

    const response = yield call(getFeedbackInsightsServicePeriod, payload);

    yield put(feedbackInsightsServicePeriodLoadedAction(response?.data || null));
  } catch (e) {
    yield put(feedbackInsightsServicePeriodFailedAction(e?.message || 'Something went wrong'));
  }
}

function* fetchOutletComparisonSaga() {
  try {
    const payload = yield buildRequestPayload();
    if (!payload) return;

    const response = yield call(getFeedbackInsightsOutletComparison, payload);

    yield put(feedbackInsightsOutletComparisonLoadedAction(response?.data || null));
  } catch (e) {
    yield put(feedbackInsightsOutletComparisonFailedAction(e?.message || 'Something went wrong'));
  }
}

export default function* watchFeedbackInsightsContainer() {
  yield takeLatest(FETCH_FEEDBACK_INSIGHTS_OVERVIEW, fetchOverviewSaga);
  yield takeLatest(FETCH_FEEDBACK_INSIGHTS_RATING_TREND, fetchRatingTrendSaga);
  yield takeLatest(FETCH_FEEDBACK_INSIGHTS_SERVICE_PERIOD, fetchServicePeriodSaga);
  yield takeLatest(FETCH_FEEDBACK_INSIGHTS_OUTLET_COMPARISON, fetchOutletComparisonSaga);
}
